<template>
  <v-card flat class="mb-6 rounded-xl border-subtle bg-dark-card">
    <v-card-title class="pa-4 pb-2">
      <div class="d-flex align-center justify-space-between w-100">
        <div>
          <div class="d-flex align-center mb-1">
            <h3 class="white--text text-subtitle-1 font-weight-black mr-3">
              {{ categoria.nombre.toUpperCase() }}
            </h3>
            <v-chip x-small outlined color="grey darken-2" class="grey--text">
              {{ categoria.productos_count }} PRODUCTOS
            </v-chip>
          </div>

          <div class="d-flex align-center flex-wrap">
            <div class="resumen-item mr-4">
              <span class="grey--text text-caption font-weight-bold">SISTEMA:</span>
              <span class="white--text text-caption ml-1">{{ categoria.total_sistema }}</span>
            </div>
            <div class="resumen-item mr-4">
              <span class="grey--text text-caption font-weight-bold">FÍSICA:</span>
              <span class="white--text text-caption ml-1">{{ categoria.total_fisica }}</span>
            </div>
            <div class="resumen-item">
              <span class="grey--text text-caption font-weight-bold">VALOR DIF.:</span>
              <span class="white--text text-caption ml-1">{{ categoria.valorizacion_diferencia | convertPesoArg }}</span>
            </div>
          </div>
        </div>

        <div class="text-right">
          <div 
            class="text-h6 font-weight-black"
            :class="categoria.diferencia < 0 ? 'red--text' : categoria.diferencia > 0 ? 'green--text' : 'grey--text'"
          >
            {{ categoria.diferencia > 0 ? "+" : "" }}{{ categoria.diferencia }}
          </div>
          <div class="grey--text text-overline leading-none">Diferencia</div>
        </div>
      </div>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-simple-table class="yt-table-resumen" dark dense>
        <thead>
          <tr>
            <th class="text-left font-weight-black">PRODUCTO</th>
            <th class="text-right font-weight-black">SISTEMA</th>
            <th class="text-right font-weight-black">FÍSICA</th>
            <th class="text-right font-weight-black">DIF.</th>
            <th class="text-right font-weight-black">VALORIZACIÓN</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="prod in categoria.productos" :key="prod.nombre">
            <td class="white--text text-caption font-weight-medium">{{ prod.nombre }}</td>
            <td class="text-right grey--text">{{ prod.cantidad_sistema }}</td>
            <td class="text-right grey--text">{{ prod.cantidad_fisica }}</td>
            <td
              class="text-right font-weight-bold"
              :class="prod.diferencia < 0 ? 'red--text text--lighten-1' : 'green--text'"
            >
              {{ prod.diferencia }}
            </td>
            <td class="text-right white--text font-mono">{{ prod.valor_diferencia | convertPesoArg }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CategoriaResumen",
  props: {
    categoria: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.bg-dark-card {
  background-color: #1a1a1a !important;
}

.border-subtle {
  border: 1px solid #282828 !important;
}

.w-100 {
  width: 100%;
}

.leading-none {
  line-height: 1;
}

.font-mono {
  font-family: 'Roboto Mono', monospace !important;
  font-size: 0.85rem;
}

/* Estilos para la tabla interna estilo reporte */
.yt-table-resumen {
  background-color: transparent !important;
}

.yt-table-resumen >>> thead th {
  color: #555 !important;
  font-size: 10px !important;
  border-bottom: 1px solid #282828 !important;
  background-color: rgba(255,255,255,0.02) !important;
}

.yt-table-resumen >>> tbody tr td {
  border-bottom: 1px solid #222 !important;
  height: 40px !important;
}

.yt-table-resumen >>> tbody tr:hover {
  background-color: rgba(255,255,255,0.03) !important;
}

.resumen-item {
  background: rgba(255,255,255,0.03);
  padding: 2px 8px;
  border-radius: 4px;
}
</style>